import {ApiBase} from "./ApiBase";
import {AxiosResponse} from "axios";

export class LoginContentApi {
 //temp endpoint - delete after POC
    public static getCountryCode(): Promise<String> {
        return ApiBase.processGetUnwrapped("/version/headers/country", (response: AxiosResponse) => {
                return response.data;
            });
    }
}